import React, {useEffect, useRef, useState} from 'react'
import EditFontDetails from "../../../design/components/design-editor/settings/edit-font-details";
import SelectColorTypeDetails from "../../../design/components/design-editor/settings/select-color-type-details";
import EditStrokeDetails from "../../../design/components/design-editor/settings/edit-stroke-details";
import EditShadowDetails from "../../../design/components/design-editor/settings/edit-shadow-details";
import EditRotationDetails from "../../../design/components/design-editor/settings/edit-rotation-details";
import EditTextPathDetails from "../../../design/components/design-editor/settings/edit-text-path-details";
import {DocumentTextIcon} from "@heroicons/react/24/solid";
import {getNextItemKey} from "../../../common/utils/item-key-util";
import {DEFAULT_TEXT_SETTINGS, KEY_PREFIX} from "../../constants/media.constant";
import {handleFieldValueChanges} from "../../../common/utils/field-change-util";
import {processColorDetails} from "../../../common/utils/color-util";
import {processTextPathData} from "../../../design/utils/svg-data.util";
import RenderFields from "../../../common/ui/render-fields";
import {TEXT_PATH_FIELD_LIST, TEXT_POSITION_FIELD_LIST} from "../../../design/constants/design.constant";
import _ from "lodash";
import DeleteItem from "../../../common/ui/delete-item";
import {processImagePositionDetails, processTextPositionDetails} from "../../../shopify/utils/position-util";

const CommonTextSection = ({
                               settings,
                               setSettings,
                               afterCommonTextAdded,
                           }) => {
    const [showCommonTextSection, setShowCommonTextSection] = useState(true);
    const [activeFontFamily, setActiveFontFamily] = useState('Open Sans');
    const [fontFamily, setFontFamily] = useState(null);
    const [fontVariants, setFontVariants] = useState(null);

    const addNewCommonText = () => {
        setShowCommonTextSection(true);

        const existingSettings = {...settings};
        console.log('existingSettings', existingSettings);

        const existingCommonTexts = existingSettings?.commonTexts || [];

        const newText = {
            isText: true,
            isEditable: true,
            isCommonText: true,
            key: getNextItemKey(existingCommonTexts, KEY_PREFIX.COMMON_TEXT),
            displayOrder: existingCommonTexts.length + 1,
            text: 'New Text',
            ...DEFAULT_TEXT_SETTINGS
        }

        existingCommonTexts.push(newText);
        existingSettings.commonTexts = existingCommonTexts;
        setSettings(existingSettings);

        afterCommonTextAdded();
    }

    const toggleCommonTextEditable = (commonTextItemIndex) => {
        const existingSettings = {...settings};
        const existingCommonTexts = existingSettings?.commonTexts;
        const commonTextItem = existingCommonTexts[commonTextItemIndex];

        commonTextItem.isEditable = !commonTextItem?.isEditable;
        existingCommonTexts[commonTextItemIndex] = commonTextItem;
        existingSettings.commonTexts = existingCommonTexts;
        setSettings(existingSettings);
    }

    const handleTextDetailChanges = (event, commonTextItemIndex) => {
        const {name, value, type} = event.target;
        const existingSettings = {...settings};
        const existingCommonTexts = existingSettings?.commonTexts;
        let commonTextItem = existingCommonTexts[commonTextItemIndex];

        commonTextItem = handleFieldValueChanges(event, commonTextItem);

        if (name === 'colorKey' || name === 'colorCodeKey' ||
            name === 'strokeColorKey' || name === 'strokeColorCodeKey' ||
            name === 'shadowColorKey' || name === 'shadowColorCodeKey') {
            processColorDetails(commonTextItem);
        } else if (name === 'radius' || name === 'rotation' || name === 'letterSpacing' ||
            name === 'startAngle' || name === 'sweepAngle') {
            processTextPathData(commonTextItem);
        } else if (name === 'offsetXPercentage') {
            let fillPatternOffsetXPercentage = _.parseInt(value);
            if (_.isNaN(fillPatternOffsetXPercentage)) {
                fillPatternOffsetXPercentage = 0;
            }

            commonTextItem.fillPatternOffsetX = -commonTextItem.totalWidth * fillPatternOffsetXPercentage / 100;
            commonTextItem.offsetX = commonTextItem.fillPatternOffsetX;
        } else if (name === 'offsetYPercentage') {
            let fillPatternOffsetYPercentage = _.parseInt(value);
            if (_.isNaN(fillPatternOffsetYPercentage)) {
                fillPatternOffsetYPercentage = 0;
            }

            commonTextItem.fillPatternOffsetY = commonTextItem.totalWidth * fillPatternOffsetYPercentage / 100;
            commonTextItem.offsetY = commonTextItem.fillPatternOffsetY;
        } else if (name === 'positionType') {
            processTextPositionDetails(value, commonTextItem, settings);
        }

        existingCommonTexts[commonTextItemIndex] = commonTextItem;
        existingSettings.commonTexts = existingCommonTexts;
        setSettings(existingSettings);

        afterCommonTextAdded();
    }

    const removeCommonTextItem = (commonTextItemIndex) => {
        const existingSettings = {...settings};
        existingSettings.commonTexts = existingSettings?.commonTexts?.filter((commonTextItem, index) => index !== commonTextItemIndex);
        setSettings(existingSettings);

        afterCommonTextAdded();
    }

    return (
        <>

            {/*<div className={'border border-gray-200 p-4 mt-4 mx-1 rounded bg-gray-100'}>*/}
            <div
                className={`border p-4 mt-4 mx-1 rounded ${showCommonTextSection ? 'bg-purple-100 border-purple-400' : 'border-gray-200 bg-gray-100'}`}>
                <div className={'flex justify-between items-center'}>
                    <div
                        className="text-purple-500 cursor-pointer ml-2 py-2 font-semibold"
                        onClick={() => {
                            setShowCommonTextSection(!showCommonTextSection);
                        }}>
                        Common Text
                    </div>

                    <button
                        className="button-sky-outline px-2 py-1 flex justify-center items-center mr-2"
                        onClick={() => {
                            addNewCommonText();
                        }}>
                        <DocumentTextIcon className="h-5 w-5"/>
                    </button>
                </div>

                <div>
                    {showCommonTextSection && settings?.commonTexts?.length > 0 &&
                        <>
                            {settings?.commonTexts?.map((commonTextItem, commonTextItemIndex) => (

                                <div key={commonTextItemIndex}
                                     className={'border border-gray-200 p-2 m-2 rounded bg-gray-100'}>

                                    <div className={'flex justify-between items-center'}>
                                        <div
                                            className="text-purple-500 cursor-pointer ml-2 py-2 font-semibold"
                                            onClick={() => {
                                                toggleCommonTextEditable(commonTextItemIndex);
                                            }}>
                                            {commonTextItem?.text}
                                        </div>

                                        <div className={'mt-1 mr-1'}>
                                            <DeleteItem
                                                handleDeleteItem={() => {
                                                    removeCommonTextItem(commonTextItemIndex);
                                                }}
                                                iconSize={'h-4 w-4'}
                                                itemIndex={commonTextItemIndex}
                                                showIcon={true}/>
                                        </div>
                                    </div>

                                    {commonTextItem?.isEditable &&

                                        <div className="mt-2">

                                            <div
                                                className="field-container w-full">
                                                <div
                                                    className="field-label">Text
                                                </div>
                                                <textarea
                                                    id="text"
                                                    name="text"
                                                    value={commonTextItem?.text}
                                                    onChange={(event) => {
                                                        handleTextDetailChanges(event, commonTextItemIndex);
                                                    }}
                                                    className="text-area-field h-28"/>
                                            </div>

                                            <EditFontDetails
                                                displayTextItem={commonTextItem}
                                                handleFontDetailsChanges={(event) => {
                                                    handleTextDetailChanges(event, commonTextItemIndex);
                                                }}/>

                                            <div className={'mt-2'}>
                                                <SelectColorTypeDetails
                                                    label={'Text Color & Shade'}
                                                    parentForm={commonTextItem}
                                                    colorAttribute={'color'}
                                                    colorKeyAttribute={'colorKey'}
                                                    colorCodeKeyAttribute={'colorCodeKey'}
                                                    settings={commonTextItem?.settings}
                                                    handleColorDetailsChanges={(event) => {
                                                        handleTextDetailChanges(event, commonTextItemIndex);
                                                    }}
                                                    handleClearColorDetailsChanges={() => {
                                                    }}/>
                                            </div>

                                            <EditStrokeDetails
                                                parentForm={commonTextItem}
                                                handleStrokeDetailsChanges={(event) => {
                                                    handleTextDetailChanges(event, commonTextItemIndex);
                                                }}/>

                                            <EditShadowDetails
                                                parentForm={commonTextItem}
                                                handleShadowDetailsChanges={(event) => {
                                                    handleTextDetailChanges(event, commonTextItemIndex);
                                                }}/>

                                            <EditRotationDetails
                                                parentItem={commonTextItem}
                                                handleRotationDetailsChanges={(event) => {
                                                    handleTextDetailChanges(event, commonTextItemIndex);
                                                }}/>

                                            <EditTextPathDetails
                                                parentItem={commonTextItem}
                                                handleTextPathDetailsChanges={(event) => {
                                                    handleTextDetailChanges(event, commonTextItemIndex);
                                                }}/>

                                            <div className="flex flex-wrap justify-start">
                                                <RenderFields
                                                    parentForm={commonTextItem}
                                                    handleDetailChanges={(event) => {
                                                        handleTextDetailChanges(event, commonTextItemIndex);
                                                    }}
                                                    fieldList={TEXT_POSITION_FIELD_LIST}
                                                    enableEdit={true}
                                                    fieldClassName={'w-1/2'}/>
                                            </div>
                                        </div>

                                    }

                                </div>
                            ))}
                        </>
                    }
                </div>
            </div>

        </>
    )
}

export default CommonTextSection
